import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { PartnerEndpoint, Url } from "../../Type/BaseUrl";

const PartnerService = createApi({
	reducerPath: "PartnerService",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			partnerContent: builder.query({
				query: () => {
					return {
						url: PartnerEndpoint,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { usePartnerContentQuery } = PartnerService;
export default PartnerService;
